'use client';

import { PlanData } from 'components';
import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

import { PlanFeatureItem } from './PlanFeatureItem';

interface PlanFeatureListProps {
    plan: PlanData;
}

const PlanFeatureSectionHeader = ({ title }: { title: string }) => {
    return (
        <Text asChild fontSize="sm" fontWeight="semibold" className="m-0">
            <h4>{title}</h4>
        </Text>
    );
};

export const PlanFeatureList = ({ plan }: PlanFeatureListProps): JSX.Element => {
    return (
        <div className="w-full flex flex-col gap-3 px-0 py-2">
            {/* Divider line */}
            <hr className="h-px bg-gray-200" />

            {/* Downloads section header */}
            <PlanFeatureSectionHeader title="Downloads" />
            {plan.features.downloads.map((feature, index) => (
                <PlanFeatureItem key={index} feature={feature} />
            ))}

            {/* Media types section header */}
            <PlanFeatureSectionHeader title="Media types" />
            {plan.features.mediaTypes.map((feature, index) => (
                <PlanFeatureItem key={index} feature={feature} />
            ))}

            {/* Workflow tools section header */}
            <PlanFeatureSectionHeader title="Workflow tools" />
            {plan.features.workflowTools.map((feature, index) => (
                <PlanFeatureItem key={index} feature={feature} />
            ))}
        </div>
    );
};
